/**
 * 请求接口配置
 */
import Config from "@/app.config";

/**
 * 请求类型定义: 不写isQuiet,则默认isQuiet为false，提示错误信息
 */
export default {
  GetGlobalConfigData: {
    url: `${Config.host.global}/AppConfig/GetH5ConfigPageData`,
    name: "获取全局配置数据",
    type: "GET",
    isQuiet: true,
  },
  Upload: {
    url: `${Config.host.shopping}/Upload/UploadPic`,
    name: "上传图片",
    type: "POST",
    isQuiet: true,
  },
  GetPayChannel_pay: {
    url: `${Config.host.pay}/PayClientH5/GetPayChannelList?commodityID=9`,
    name: "获取支付通道信息",
    isQuiet: true,
  },

  SearchOrderByPayClient: {
    url: `${Config.host.pay}/PayClientH5/SearchOrder`,
    name: "查询订单[支付中心]",
    type: "GET",
    isQuiet: true,
  },
  LogoutReceive: {
    url: `${Config.host.activity}/Activity/Api/Logout`,
    name: "微信退出登录状态",
    isQuiet: true,
  },

  GetOrderDetailListByGoodsID: {
    url: `${Config.host.shopping}/Order/GetOrderDetailListByGoodsID`,
    name: "获取某个用户某个商品所有购买记录",
    isQuiet: true,
  },
  Login: {
    url: `${Config.host.activity}/Activity/Page/Login`,
    name: "微信登录",
    isQuiet: true,
  },
  GetOpenUser: {
    url: `${Config.host.activity}/Activity/Page/GetOpenUser`,
    name: "微信授权",
    isQuiet: true,
  },
  PageAreaData: {
    url: `${Config.host.shopping}/pagedata/PageAreaData`,
    name: "页面区域数据",
    isQuiet: true,
    type: "GET",
  },
  PageCollectData: {
    url: `${Config.host.shopping}/pagedata/PageCollectData`,
    name: "页面集合数据",
    isQuiet: true,
    type: "GET",
  },
  PageInfoData: {
    url: `${Config.host.shopping}/pagedata/PageData`,
    name: "页面数据",
    isQuiet: true,
    type: "GET",
  },
  GoodsDetailResult: {
    url: `${Config.host.shopping}/Goods/GoodsDetailResult`,
    name: "商品详细信息",
    isQuiet: true,
  },
  GetOrderGoodsSnapshot: {
    url: `${Config.host.shopping}/Order/GetOrderGoodsSnapshot`,
    name: "商品快照信息",
    isQuiet: true,
  },
  FlashSaleGoodsDetail: {
    url: `${Config.host.shopping}/FlashSale/FlashSaleGoodsDetailResult`,
    name: "秒杀商品详细信息",
    isQuiet: true,
  },
  ChangeUserAddress: {
    url: `${Config.host.udb}/AddressApi/H5ChangeUserAddress`,
    name: "新增修改收货地址",
    isQuiet: false,
  },

  UserAddressResultList: {
    url: `${Config.host.udb}/AddressApi/GetUserAddressList`,
    name: "收货地址列表",
    isQuiet: true,
  },

  DeleteUserAddress: {
    url: `${Config.host.udb}/AddressApi/H5DeleteUserAddress`,
    name: "删除收货地址",
    isQuiet: false,
  },

  OrderDetailList: {
    url: `${Config.host.shopping}/Order/GetAccountOrderDetailList`,
    name: "订单列表",
    isQuiet: true,
  },
  OrderDetailListByProduct: {
    url: `${Config.host.shopping}/Order/GetBuguOrderDetailList`,
    name: "订单列表",
    isQuiet: true,
  },
  OrderDetail: {
    url: `${Config.host.shopping}/Order/OrderDetail`,
    name: "订单详情",
    type: "GET",
    isQuiet: true,
  },
  OrderExpress: {
    url: `${Config.host.shopping}/Order/GetOrderExpress`,
    name: "订单物流",
    type: "GET",
    isQuiet: true,
  },
  ChangeOrderAddress: {
    url: `${Config.host.shopping}/Order/UpdateOrderAddress`,
    name: "修改订单收货地址",
  },
  GetVoucherDetail: {
    url: `${Config.host.shopping}/Order/GetVoucherDetail`,
    name: "获取优惠券关联商品",
    isQuiet: false,
  },
  GoodsVoucherList: {
    url: `${Config.host.udb}/ApiH5/GoodsVoucherList`,
    name: "商品可用优惠券H5",
    isQuiet: false,
  },
  GetVoucherList: {
    url: `${Config.host.udb}/ApiH5/GetVoucherList`,
    name: "获取用户优惠券列表",
    isQuiet: false,
  },
  ReceiveVoucher: {
    url: `${Config.host.udb}/ApiH5/ReceiveVoucher`,
    name: "领取优惠券H5",
    isQuiet: false,
  },
  CreateOrder: {
    url: `${Config.host.shopping}/Order/CreateOrder`,
    name: "创建订单",
    isQuiet: false,
  },
  CancelOrder: {
    url: `${Config.host.shopping}/Order/CancelOrder`,
    name: "取消订单",
    isQuiet: false,
  },
  SearchOrder: {
    url: `${Config.host.shopping}/Order/SearchOrder`,
    name: "查询订单",
    type: "GET",
    isQuiet: true,
  },
  AddShoppingCart: {
    url: `${Config.host.shopping}/ShoppingCart/AddShoppingCart`,
    name: "加入购物车",
    isQuiet: true,
  },
  GetUserCartList: {
    url: `${Config.host.shopping}/ShoppingCart/GetUserCartList`,
    name: "用户购物车列表",
    isQuiet: true,
  },
  ChangeCartCount: {
    url: `${Config.host.shopping}/ShoppingCart/ChangeCartCount`,
    name: "购物车-修改商品数量",
    isQuiet: true,
  },
  ChangeCartChecked: {
    url: `${Config.host.shopping}/ShoppingCart/ChangeCartChecked`,
    name: "购物车-选中/取消商品",
    isQuiet: true,
  },
  ChangeCartAllChecked: {
    url: `${Config.host.shopping}/ShoppingCart/ChangeCartAllChecked`,
    name: "购物车-全选/取消全选",
    isQuiet: true,
  },
  ChangeCartSku: {
    url: `${Config.host.shopping}/ShoppingCart/ChangeCartSku`,
    name: "购物车-换规格",
    isQuiet: true,
  },
  DeleteShoppingCart: {
    url: `${Config.host.shopping}/ShoppingCart/DeleteShopingCart`,
    name: "购物车-删除商品",
    isQuiet: true,
  },
  GetUserCartCount: {
    url: `${Config.host.shopping}/ShoppingCart/GetUserCartCount`,
    name: "购物车-获取购物车商品数量",
    isQuiet: true,
  },
  WeChatResult: {
    url: `${Config.host.shopping}/WeChat/WeChatResult`,
    name: "获取客服微信",
    isQuiet: true,
  },
  AfterSaleService: {
    url: `${Config.host.udb}/Account/AfterSaleService`,
    name: "获取商城服务协议",
    isQuiet: true,
  },
  Licence: {
    url: `${Config.host.udb}/Account/Licence`,
    name: "获取执照信息",
    type: "GET",
    isQuiet: true,
  },
  FreightPrice: {
    url: `${Config.host.shopping}/Freight/FreightPrice`,
    name: "获取运费",
    isQuiet: true,
  },
  FreightRuleList: {
    url: `${Config.host.shopping}/Freight/FreightRuleList`,
    name: "获取运费规则列表",
    isQuiet: true,
  },
  ActivityDetailList: {
    url: `${Config.host.shopping}/Activity/ActivityDetailList`,
    name: "获取促销活动列表",
    isQuiet: true,
  },
  ActivityGoodsPage: {
    url: `${Config.host.shopping}/Activity/ActivityGoodsPage`,
    name: "获取促销活动商品列表",
    isQuiet: true,
  },
  CompleteTaskInfo: {
    url: `${Config.host.shopping}/TaskInfo/CompleteTaskInfo`,
    name: "完成任务",
    isQuiet: true,
  },
  GetTaskInfo: {
    url: `${Config.host.shopping}/TaskInfo/GetTaskInfo`,
    name: "获取任务信息",
    isQuiet: true,
    type: "GET",
  },
  GetUserSignData: {
    url: `${Config.host.shopping}/TaskInfo/GetUserSignData`,
    name: "获取任务签到",
    isQuiet: true,
  },
  GetAccountIntegral: {
    url: `${Config.host.shopping}/Integral/GetAccountIntegral`,
    name: "获取账号积分",
    isQuiet: true,
  },
  GetAccountExpireIntegral: {
    url: `${Config.host.shopping}/Integral/GetAccountExpireIntegral`,
    name: "获取账号过期积分",
    isQuiet: true,
  },
  GetIntegralPage: {
    url: `${Config.host.shopping}/Integral/GetIntegralPage`,
    name: "获取账号积分流水",
    isQuiet: true,
  },
  // 帮助中心
  GetContent: {
    url: `${Config.host.help}/h5api/Question/GetContent`,
    name: "问题-获取问题HTML内容",
    isQuiet: true,
    type: "GET",
  },
  // 礼包中心-创建礼包
  CreateVoucherPackage: {
    url: `${Config.host.shopping}/VoucherPackage/CreateVoucherPackage`,
    name: "优惠券礼包-创建礼包",
    isQuiet: true,
  },
  // 礼包中心-礼包列表
  GetVoucherPackageList: {
    url: `${Config.host.shopping}/VoucherPackage/GetVoucherPackageList`,
    name: "优惠券礼包-礼包列表",
    isQuiet: true,
    type: "GET",
  },
  // 礼包中心-礼包详情
  GetVoucherPackageDetail: {
    url: `${Config.host.shopping}/VoucherPackage/GetVoucherPackageDetail`,
    name: "优惠券礼包-礼包详情",
    isQuiet: true,
    type: "GET",
  },
  // 礼包中心-礼包详情
  GetVoucherPackageData: {
    url: `${Config.host.shopping}/VoucherPackage/GetVoucherPackageData`,
    name: "优惠券礼包-优惠券列表",
    isQuiet: true,
    type: "GET",
  },
  // 礼包中心-礼包领取
  HandOutUserVoucherPackage: {
    url: `${Config.host.shopping}/VoucherPackage/HandOutUserVoucherPackage`,
    name: "优惠券礼包-礼包领取",
    isQuiet: true,
  },
  // 礼包中心-礼包领取记录
  GetVoucherPackageHandOutList: {
    url: `${Config.host.shopping}/VoucherPackage/GetVoucherPackageHandOutList`,
    name: "优惠券礼包-礼包领取记录",
    isQuiet: true,
    type: "GET",
  },
  // 礼包中心-礼包领取信息
  GetUserVoucherPackageInfo: {
    url: `${Config.host.shopping}/VoucherPackage/GetUserVoucherPackageInfo`,
    name: "优惠券礼包-礼包领取详情",
    isQuiet: true,
    type: "GET",
  },
  //礼包中心-判断用户是否在礼包白名单
  GetVoucherPackagePermissions: {
    url: `${Config.host.shopping}/VoucherPackage/CheckPowerUser`,
    name: "获取用户礼包中心权限",
    isQuiet: true,
    type: "GET",
  },
  //用户中心-获取用户信息
  GetUserInfo: {
    url: `${Config.host.activity}/Activity/Extra/UserInfo`,
    name: "获取用户信息",
    isQuiet: false,
    type: "GET",
  },
  //用户账号事件数据上报
  AccountEventData: {
    url: `${Config.host.shopping}/User/AccountEventData`,
    name: "账号事件数据上报",
    isQuiet: true,
    type: "GET",
  },
  //兑换码兑换接口
  RedeemCode: {
    url: `${Config.host.udb}/VoucherApi/ExchangeVoucherH5`,
    name: "兑换码兑换接口",
    isQuiet: false,
    type: "POST",
  },
  //搜索商品结果
  GetSearchResult: {
    url: `${Config.host.shopping}/Goods/GetSearchResult`,
    name: "搜索商品",
    isQuiet: true,
    type: "GET",
  },
  TaskIntegralPage: {
    url: `${Config.host.shopping}/PageData/TaskIntegralPage`,
    name: "商城积分页",
    isQuiet: true,
    type: "GET",
  },

  /** 促销相关 */
  /** 获取商品促销活动列表 */
  GetGoodsPromotion: {
    url: `${Config.host.shopping}/Promotion/GetGoodsPromotion`,
    name: "获取商品促销活动列表",
    isQuiet: true,
    type: "GET",
  },

  /** 获取促销活动详细 */
  GetPromotionDetail: {
    url: `${Config.host.shopping}/Promotion/GetPromotionDetail`,
    name: "获取促销活动详细",
    isQuiet: true,
    type: "GET",
  },

  /** 获取促销活动描述/规则 */
  GetPromotionDes: {
    url: `${Config.host.shopping}/Promotion/GetPromotionDes`,
    name: "获取促销活动描述/规则",
    isQuiet: true,
    type: "GET",
  },

  /** 凑单 */
  TopupOrder: {
    url: `${Config.host.shopping}/Order/TopupOrder`,
    name: "凑单",
    isQuiet: true,
    type: "POST",
  },

  /** 预下单 */
  PreCreateOrder: {
    url: `${Config.host.shopping}/Order/PreCreateOrder`,
    name: "预下单",
    isQuiet: true,
    type: "POST",
  },

  /** 获取上传云STS */
  GetStsToken: {
    url: `${Config.host.shopping}/Order/GetStsToken`,
    name: "获取上传云STS",
    isQuiet: true,
    type: "GET",
  },
  /** 收货地址识别 */
  GetExtractAddress: {
    url: `${Config.host.shopping}/Order/GetExtractAddress`,
    name: "收货地址识别",
    isQuiet: true,
    type: "GET",
  },

  /** 获取协商记录 */
  GetRefundNegotiationList: {
    url: `${Config.host.shopping}/Refund/GetRefundNegotiationList`,
    name: "获取协商记录",
    isQuiet: true,
    type: "GET",
  },
  /** 获取快递公司 */
  GetExpressCompanyInfoResultList: {
    url: `${Config.host.shopping}/Refund/GetExpressCompanyInfoResultList`,
    name: "获取快递公司",
    isQuiet: true,
    type: "GET",
  },
  /** 填写快递信息 */
  CreateRefundExpress: {
    url: `${Config.host.shopping}/Refund/CreateRefundExpress`,
    name: "填写快递信息",
    isQuiet: true,
    type: "POST",
  },
  /** 获取退款详细 */
  GetRefundDetail: {
    url: `${Config.host.shopping}/Refund/GetRefundDetail`,
    name: "获取退款详细",
    isQuiet: true,
    type: "GET",
  },
  /** 取消退款 */
  RefundCancel: {
    url: `${Config.host.shopping}/Refund/RefundCancel`,
    name: "取消退款",
    isQuiet: true,
    type: "GET",
  },
  /** 修改申请退款*/
  UpdateApplyRefund: {
    url: `${Config.host.shopping}/Refund/UpdateApplyRefund`,
    name: "修改申请退款",
    isQuiet: true,
    type: "POST",
  },
  /** 申请退款*/
  CreateApplyRefund: {
    url: `${Config.host.shopping}/Refund/CreateApplyRefund`,
    name: "申请退款",
    isQuiet: true,
    type: "POST",
  },
  /** 活动信息 */
  ActivityData: {
    url: `${Config.host.activity}/Activity/Api/ActivityData_App`,
    name: "活动-首页",
    isQuiet: false,
    type: "GET",
  },

  /** 活动图片 */
  ActivityPicture: {
    url: `${Config.host.activity}/Activity/Api/ActivityPicture_App`,
    name: "活动-图片",
    isQuiet: false,
    type: "GET",
  },

  /** 活动抽奖 */
  ActivityLottery: {
    url: `${Config.host.activity}/Activity/Api/Lottery_App`,
    name: "活动-抽奖",
    isQuiet: false,
    type: "GET",
  },
  /** 获取客服系统用户未读消息数 */
  GetUserUnreadCount: {
    url: `${Config.host.imservice}/api/UserInfo/H5GetUserUnreadCount`,
    name: "获取用户未读消息数（H5用）",
    isQuiet: false,
    type: "POST",
  },
  /** 获取商品sku列表 */
  GetGoodsSkuList: {
    url: `${Config.host.shopping}/Goods/SkuDetailResultList`,
    name: "获取商品sku列表",
    isQuiet: true,
    type: "GET",
  },
};
